import { call, put, takeEvery, select } from "redux-saga/effects";
import { types } from "../action-types";
import {
    fetchUserProfileFailure,
    fetchUserProfileSuccess,
} from "../actions";
import {
    fetchProfileURL, getMyABSAPI,
} from "../../API/API";

function* fetchProfileSaga(request) {
    try {
        const response = yield call(() => fetchProfileURL(request.payload)); // API Backend
        if (response.data.status === true) {
            const ProfileImageKey = response.data.data.body.user.Profiles.PictureUrl
            const firstName = response.data.data.body.user.Profiles.FirstName;
            // console.log('FetchProfileSaga check response',response.data.data.body.user.Profiles.PictureUrl);
            localStorage.setItem('profilePicture',JSON.stringify(ProfileImageKey))
            localStorage.setItem('profileName',JSON.stringify(firstName))
            const user = response.data.data.body.user;
            yield put(fetchUserProfileSuccess(user));

            if (
                user?.MasterAccountId === null ||
                user?.MasterAccountId === undefined
            ) {
                yield put({ type: types.FETCH_CREDITS_BALANCE_REQUESTED });
            }
        } else {
            yield put(fetchUserProfileFailure(response.data.error));
        }
    } catch (error) {
        console.warn(error);
        yield put(fetchUserProfileFailure(error));
    }
}

function* fetchABSSaga(action) {
    try {
      const { page, limit } = action.payload || { page: 1, limit: 5 };
      const response = yield call(getMyABSAPI, page, limit);
      yield put({ type: types.GET_ABS_ACCOUNTS_SUCCESS, payload: response.data });
    } catch (error) {
      yield put({ type: types.GET_ABS_ACCOUNTS_FAILURE, error });
    }
  }

export function* watchProfileSaga() {
    yield takeEvery(types.FETCH_PROFILE_INIT, fetchProfileSaga);
}
export function* watchGetABsSaga() {
    yield takeEvery(types.GET_ABS_ACCOUNTS, fetchABSSaga);
}
